import { IInjectable } from '@uirouter/angularjs';
import { IQService } from 'angular';

export function LoadScriptResolver(options: {
  id: string;
  url: string;
  integrity?: string;
  crossOrigin?: string;
  referrerPolicy?: string;
  module?: boolean;
}): IInjectable {
  return [
    '$q',
    function loadScript($q: IQService) {
      const q = $q.defer<boolean>();

      const container = document.body;
      let scriptElement: HTMLScriptElement | null = document.querySelector(`#${options.id}`);

      if (scriptElement) {
        q.resolve(true);
        return q.promise;
      }

      scriptElement = document.createElement('script');
      scriptElement.id = options.id;
      scriptElement.src = options.url;

      if (options.module) {
        scriptElement.type = 'module';
      }

      if (options.integrity) {
        scriptElement.integrity = options.integrity;
      }

      if (options.crossOrigin) {
        scriptElement.crossOrigin = options.crossOrigin;
      }

      if (options.referrerPolicy) {
        scriptElement.referrerPolicy = options.referrerPolicy;
      }

      scriptElement.addEventListener('load', () => {
        q.resolve(true);
      });

      scriptElement.addEventListener('error', () => {
        scriptElement?.remove();
        q.reject(false);
      });

      container.appendChild(scriptElement);

      return q.promise;
    },
  ];
}
